<template>
    <th :class="[column.align, column.imageSrc ? 'tiny-image' : '' , ...column.headerClassList]" :width="column.width">
        <template v-if="column.label">
            <span v-if="column.sortable" class="clickable" @click="setSortBy(column.key)">
                {{ column.label }}
                <i v-if="filters.sort_by == column.key" :class="['fa-solid', filters.sort_order == 'asc' ? 'fa-caret-down' : 'fa-caret-up']"></i>
                <i v-else :class="['fa-solid', 'fa-sort']" style="color: #666;"></i>
            </span>
            <span v-else>
                {{ column.label }}
            </span>
        </template>
    </th>
</template>

<script>
    export default {
        name: 'ProductTableHeader',
        props: {
            column: {
                type: Object,
                required: true,
            },
            filters: {
                type: Object,
                required: false,
            },
        },
        methods: {
            setSortBy(column) {
                if (this.filters.sort_by === column) {
                    this.toggleFilter('sort_order');
                } else {
                    this.$emit('update:filters', { ...this.filters, sort_by: column, sort_order: 'asc' });
                }
            },
            toggleFilter(filterKey) {
                const newValue = this.filters[filterKey] === 'asc' ? 'desc' : 'asc';
                this.$emit('update:filters', { ...this.filters, [filterKey]: newValue });
            },
        },
    }
</script>

<style lang="scss" scoped>
th {
    padding: 0.66em 0;
    text-transform: uppercase;
    color: #4a4a4a;
    background: #ededed;
    font-size: 0.9rem;
    border-bottom: 1px dotted #dfdce3;

    &:first-child {
        padding-left: 0.5em;
    }
}
</style>